<script lang="ts">export let label = '';
export let type = '';
</script>

<button class="btn btn-primary btn-block" {type}>{label}</button>
